import axios from "axios";
import { GET_ALL_QUOTA } from "./types";
const keys = require("../config/keys");

export const getAllQuota = AdmFormGroupId => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/AdmissionForm/GetAllAdmissionQuotaList?AdmFormGroupId=" +
      AdmFormGroupId
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_QUOTA,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAllQuota.js